import { EventEmitter } from '@angular/core';
import { Route } from 'app/types/route-data';
import { Injectable } from '@angular/core';
import { ReportMode, ReportsComponent, SubMode } from 'app/components/reports/reports.component';
import { ReportSummaryComponent } from 'app/components/reports/report-summary/report-summary.component';
import { RouteTally } from './data-manager.service';
import { ReportCostsComponent } from 'app/components/reports/report-costs/report-costs.component';

export type Totals = { [key: string]: number };

@Injectable({
  providedIn: 'root'
})
export class ReportingService {

  private _route?: Route;
  private _totals?: Totals;
  private _supplTotals?: Totals;
  private _subMode?: SubMode;

  public totalsChange = new EventEmitter<Totals>();
  constructor() { }

  SetSupplTotals(suppl: Totals) {
    this._supplTotals = suppl;
    this.Update();
  }
  private _summaryTally?: RouteTally;
  private _summary?:ReportSummaryComponent;

  SetSummaryComponent(summary: ReportSummaryComponent) {
    this._summary = summary;
    summary.tallyChange.subscribe((tally: RouteTally) => {
      this._summaryTally = tally;
      this.Update();
    })
  }
  private _cost?:ReportCostsComponent;
  SetCostsComponent(cost: ReportCostsComponent) {
    this._cost = cost;
    this._cost.featuresChange.subscribe((features: Array<any>) => {
      this._totals!.length = this._cost!.GetLength();
      this.Update();
    })
  }

  private  _reports?:ReportsComponent;
  SetReportsComponent(rpt:ReportsComponent) {
    this._reports = rpt;
  }

  SetReport(mode:ReportMode) {
    if(!this._reports) return;
    this._reports.reportMode = mode;
  }

  SetRoute(route: Route) {
    this._route = route;
    this.Update();
  }

  ResetTotals() {
    this._totals = {
      materials: 0,
      labor: 0,
      supplemental: 0,
      grand: 0
    }
  }
  Update() {
    if (!this._route) return;
    this._subMode = this._route?.expanded ? '*' : '*+';

    this.ResetTotals();
    this._totals!.length = this._cost!.GetLength();
    const totals = this._totals!;
    const tally = this._route.feature.GetTally(this._subMode, this._route.id, this._route);
    for (let key in tally) {
      if (!tally.hasOwnProperty(key)) continue;
      const entry = tally[key];
      if (!entry) continue;
      totals.labor += (!!entry.costs.labor) ? entry.costs.labor : 0;
      totals.materials += (!!entry.costs.materials) ? entry.costs.materials : 0;

    }
    totals.grand += totals.labor + totals.materials;
    this.totalsChange.emit(totals);
  }
}
